"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = exports.AuthProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ApiClient_1 = require("../ApiClient");
const AuthContext = (0, react_1.createContext)(undefined);
const AuthProvider = ({ children }) => {
    const [user, setUser] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        // Raw fetch, not apiClient: a 401 here means "not signed in yet" — the
        // normal state on first load, not a session that expired mid-use.
        fetch('/api/auth/me', { credentials: 'include' })
            .then((response) => (response.ok ? response.json() : null))
            .then(setUser)
            .finally(() => setLoading(false));
    }, []);
    const logout = async () => {
        await ApiClient_1.apiClient.delete('/api/auth/session');
        setUser(null);
    };
    return (0, jsx_runtime_1.jsx)(AuthContext.Provider, { value: { user, loading, login: setUser, logout }, children: children });
};
exports.AuthProvider = AuthProvider;
const useAuth = () => {
    const context = (0, react_1.useContext)(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
exports.useAuth = useAuth;
